module.exports = __webpack_public_path__ + "static/images/callout_1.f95ca65d4c41293690ddd7a09d91bdfe.jpg";